import { RootState } from 'store/rootSlices';

export const getAppSlice = (state: RootState) => state.App;
export const getLogsSlice = (state: RootState) => state.Logs;
